/**
 * Qrew HR — Role-based Route Guard
 *
 * Wrap any route element to enforce role visibility on the FRONTEND.
 * Backend scope checks should still be enforced where possible — this is
 * the second line of defense + UX layer.
 */
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Lock } from "lucide-react";
import { Link } from "react-router-dom";

export default function RoleGate({ allow = [], children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;

  // Wildcard
  if (!allow.length) return children;

  // Admin family always allowed unless explicitly excluded
  const role = user.role;
  if (allow.includes(role)) return children;

  return (
    <div className="p-6 lg:p-12 max-w-2xl mx-auto" data-testid="access-denied">
      <Card className="p-8 sm:p-10 text-center border-amber-200 bg-amber-50/40">
        <div className="inline-flex w-14 h-14 rounded-2xl bg-amber-100 text-amber-600 items-center justify-center mb-4">
          <Lock className="w-7 h-7" />
        </div>
        <h2 className="text-xl font-bold font-[Outfit] text-slate-900">Access restricted</h2>
        <p className="text-sm text-slate-600 mt-2">
          This area is reserved for {allow.map(r => r.replace("_", " ")).join(" / ")}.
          Your role <span className="font-semibold capitalize">{role?.replace("_", " ")}</span> does not have access.
        </p>
        <Link to="/" className="qh-btn btn-primary qh-btn-sm mt-5 inline-flex">Back to Dashboard</Link>
      </Card>
    </div>
  );
}
